<template>
    <div class="keycare-setting">
        <el-tabs v-model="activeName">
            <el-tab-pane label="体检项目设置" name="items">
                <zk-admin-table title="体检项目管理" :loading="loading" :table="table" @change="handleTableChange">
                    <template v-slot:buttons>
                        <el-row style="float: right">
                            <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">新增项目</el-button>
                            <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
                        </el-row>
                    </template>

                    <template v-slot:search>
                        <zk-search-form-inline :form="search" @search="getData">
                            <el-form-item label="项目名称">
                                <el-input v-model.trim="search.name" clearable style="width:150px" placeholder="请输入项目名称"></el-input>
                            </el-form-item>
                        </zk-search-form-inline>
                    </template>

                    <el-table-column type="index" width="50" align="center" />
                    <el-table-column prop="label" label="项目名称" align="center" />
                    <el-table-column prop="price" label="价格(元)" width="150" align="center">
                         <template slot-scope="scope">
                            {{ scope.row.price }} 元
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="说明" align="center" />
                    <el-table-column prop="status" label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini">
                                {{ scope.row.status ? '启用' : '禁用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column align="center" width="180" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                    <template v-slot:dialog>
                        <el-dialog :title="form.id ? '编辑项目' : '新增项目'" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
                            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                                <el-form-item label="项目名称" prop="label">
                                    <el-input v-model.trim="form.label" placeholder="请输入项目名称"></el-input>
                                </el-form-item>
                                <el-form-item label="价格" prop="price">
                                    <el-input-number v-model="form.price" :min="0" :step="100" style="width: 100%;"></el-input-number>
                                </el-form-item>
                                <el-form-item label="说明" prop="description">
                                    <el-input type="textarea" v-model.trim="form.description" placeholder="请输入项目说明"></el-input>
                                </el-form-item>
                                <el-form-item label="状态" prop="status">
                                    <el-switch v-model="form.status" active-text="启用" inactive-text="禁用"></el-switch>
                                </el-form-item>
                            </el-form>
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="dialogVisible = false">取 消</el-button>
                                <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
                            </span>
                        </el-dialog>
                    </template>
                </zk-admin-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: 'keycare_setting',
    path: '/main/keycare/setting',
    meta: {
        title: '精准关怀体检设置',
    },
    data() {
        return {
            loading: false,
            activeName: 'items',
            dialogVisible: false,
            search: {
                name: ''
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                label: '',
                price: 0,
                description: '',
                status: true
            },
            rules: {
                label: [
                    { required: true, message: '请输入项目名称', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' }
                ]
            },
            // Initial mock data based on register.vue
            mockData: [
                { id: 1, label: 'CTA', price: 1200, description: 'CT血管造影', status: true },
                { id: 2, label: 'MRA', price: 1000, description: '磁共振血管成像', status: true },
                { id: 3, label: '心脏彩超', price: 300, description: '超声心动图', status: true },
                { id: 4, label: '颈动脉彩超', price: 200, description: '颈部血管超声', status: true },
                { id: 5, label: '胸部CT', price: 400, description: '胸部计算机断层扫描', status: true }
            ]
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            try {
                // In a real app, fetch from API
                // const resp = await this.$http.get('/keycare/items', { params: { ...this.search, page: this.table.page, pageSize: this.table.pageSize } });
                
                // Mock data filtering
                let filteredData = this.mockData.filter(item => {
                    if (this.search.name && !item.label.includes(this.search.name)) return false;
                    return true;
                });
                
                this.table.data = filteredData;
                this.table.total = filteredData.length;
                
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleAdd() {
            this.form = {
                label: '',
                price: 0,
                description: '',
                status: true
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleUpdate(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleDelete(row) {
             this.$confirm('确认删除该项目吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // Mock deletion
                this.mockData = this.mockData.filter(item => item.id !== row.id);
                this.$message.success('删除成功 (演示)');
                this.getData();
            }).catch(() => {});
        },
        async handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    try {
                        // Mock submission
                        if (this.form.id) {
                            // Update
                            const index = this.mockData.findIndex(item => item.id === this.form.id);
                            if (index !== -1) {
                                this.mockData.splice(index, 1, { ...this.form });
                            }
                        } else {
                            // Create
                            this.mockData.push({
                                id: Date.now(),
                                ...this.form
                            });
                        }
                        
                        await new Promise(resolve => setTimeout(resolve, 500));
                        this.$message.success('保存成功 (演示)');
                        this.dialogVisible = false;
                        this.getData();
                    } catch (e) {
                        this.$message.error(e.message || '提交失败');
                    }
                    this.loading = false;
                }
            });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.keycare-setting {
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 120px);
}
</style>
